import { Dialog as MUIDialog } from "@mui/material";
import { CircularProgress } from "@mui/material";
import clsx from "clsx";
import { ReactElement } from "react";
import { Button } from "components/Button";
import { Icon } from "components/Icon";

type ConfirmationType = {
  isOpen: boolean;
  isLoading?: boolean;
  canClose?: boolean;
  title?: string;
  description?: string | ReactElement;
  onSubmit: () => void;
  onClose: () => void;
  type?: "warning" | "info" | "success";
};

export function ConfirmationModal(props: ConfirmationType) {
  const {
    isOpen = false,
    isLoading = false,
    canClose = true,
    title,
    description,
    onSubmit,
    onClose,
    type = "warning",
  } = props;

  const getTextColorClassNameBaseOnType = () => {
    switch (type) {
      case "warning":
        return "text-error-80";
      case "success":
        return "text-success-80";
      case "info":
        return "text-info-90";
      default:
        return "text-primary-90";
    }
  };

  return (
    <MUIDialog
      open={isOpen}
      // onClose={canClose ? onClose : () => {}}
      PaperProps={{ className: "bg-neutral-05 min-w-[320px]" }}
    >
      <div className="flex px-5 mt-5">
        <Icon
          icon="MdClose"
          className="cursor-pointer text-gray-70 hover:text-Gray-130 absolute top-2 left-2 text-xl"
          onClick={() => {
            canClose && onClose && onClose();
          }}
        />
        <div
          className={clsx(
            "flex-1 flex items-center text-base font-bold",
            getTextColorClassNameBaseOnType()
          )}
        >
          {title}
        </div>
      </div>
      <div className="overflow-y-auto p-2 m-2 gap-y-3">
        <div className="px-4 mt-3">{description}</div>
        <div className="flex items-center justify-end mt-6">
          {isLoading && <CircularProgress size={24} color="inherit" />}
          {!isLoading && (
            <>
              <Button
                className="text-gray-60"
                onClick={canClose ? onClose : undefined}
                id="cancel_dialog"
              >
                لغو
              </Button>
              <Button
                className={getTextColorClassNameBaseOnType()}
                onClick={onSubmit}
                id="confirm_dialog"
              >
                تایید
              </Button>
            </>
          )}
        </div>
      </div>
    </MUIDialog>
  );
}
